import type { IUser } from "@/modules/auth/common/types";
import { Storage } from "@/shared/common/enums";

export const setToLocalStorage = (key: string, value?: string) => {
  if (value) {
    localStorage.setItem(key, value);
  }
};

export const setToSessionStorage = (key: string, value?: string | null) => {
  if (value) {
    sessionStorage.setItem(key, value);
  }
};

export const getFromLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const getFromSessionStorage = (key: string) => {
  return sessionStorage.getItem(key);
};

export const clearUserFromStorage = () => {
  localStorage.removeItem(Storage.ClientName);
  localStorage.removeItem(Storage.FullName);
  localStorage.removeItem(Storage.PhoneNumber);
  localStorage.removeItem(Storage.Email);
  localStorage.removeItem(Storage.Tin);
  localStorage.removeItem(Storage.IsAuth);
};

export const setUserToStorage = (data: IUser) => {
  setToLocalStorage(Storage.ClientCode, data.clientCode);
  setToLocalStorage(Storage.ClientName, data.clientName);
  setToLocalStorage(Storage.FullName, data.fullName);
  setToLocalStorage(Storage.PhoneNumber, data.phoneNumber);
  setToLocalStorage(Storage.Email, data.email);
  setToLocalStorage(Storage.Tin, data.taxCode);
};

export const getUserFromStorage = () => {
  const clientName = getFromLocalStorage(Storage.ClientName);
  const clientCode = getFromLocalStorage(Storage.ClientCode);
  const fullName = getFromLocalStorage(Storage.FullName);
  const phoneNumber = getFromLocalStorage(Storage.PhoneNumber);
  const email = getFromLocalStorage(Storage.Email);
  const tin = getFromLocalStorage(Storage.Tin);
  return {
    clientName,
    clientCode,
    fullName,
    phoneNumber,
    email,
    tin
  };
};
